import { DataOptions } from "vuetify/types";

export class DefaultDataOptions implements DataOptions {
  groupBy = [];
  groupDesc = [];
  itemsPerPage = 10;
  multiSort = false;
  mustSort = false;
  page = 1;
  sortBy = [];
  sortDesc = [];
}

export class DataTableOptions {
  options: DataOptions = new DefaultDataOptions();
  serverItemsLength = -1;
}

export default DataTableOptions;
